import React from 'react';
import { Helmet } from 'react-helmet-async';
import CareersPageComponent from '../components/CareersPage';

const Careers = () => {
    return (
        <>
            <Helmet>
                <title>Careers - Community Plus Care Services</title>
                <meta name="description" content="Join our team at Community Plus Care Services. Explore career opportunities in disability support, mental health, administration, and more." />
            </Helmet>
            <CareersPageComponent />
        </>
    );
};

export default Careers;
